import module from 'colaborador/module'
import template from './template.html'

export class ColaboradorCajaAhorroConfirmarComponent {
  idProyecto
  idColaborador
  onClose
  accion
  procesando
  procesado
  data = {}

  constructor (ColaboradorCajaAhorroAportaciones) {
    this.ColaboradorCajaAhorroAportaciones = ColaboradorCajaAhorroAportaciones
  }

  agregar () {
    if (this.procesando) {
      return
    }

    this.procesando = true

    this.ColaboradorCajaAhorroAportaciones.post(this.data, this.idProyecto, this.idColaborador)
    .then(() => (this.procesado = true))
    .catch((error) => (this.error = error.data || error))
    .finally(() => (this.procesando = false))
  }

  eliminar () {
    if (this.procesando) {
      return
    }

    this.procesando = true

    this.ColaboradorCajaAhorroAportaciones.delete(this.data.id)
      .then(() => (this.procesado = true))
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.procesando = false))
  }

  modificar () {
    if (this.procesando) {
      return
    }

    this.procesando = true

    this.ColaboradorCajaAhorroAportaciones.put(this.data, this.idProyecto, this.idColaborador)
    .then(() => (this.procesado = true))
    .catch((error) => (this.error = error.data || error))
    .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose()
  }

  guardar () {
    if (this.accion === 1) {
      this.agregar()
    } else if (this.accion === 2) {
      this.modificar()
    } else if (this.accion === 3) {
      this.eliminar()
    }
  }

  finalizar () {
    this.onClose({$event: {data: this.procesado}})
  }
}

module.component('colaboradorCajaAhorroConfirmar', {
  controller: ColaboradorCajaAhorroConfirmarComponent,
  template,
  bindings: {
    accion: '<', // 1 agregar, 2 modificar
    idProyecto: '<',
    idColaborador: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/aportaciones/confirmar/component.js